import { render, staticRenderFns } from "./taskPublish.vue?vue&type=template&id=031955c2&scoped=true"
import script from "./taskPublish.vue?vue&type=script&lang=js"
export * from "./taskPublish.vue?vue&type=script&lang=js"
import style0 from "./taskPublish.vue?vue&type=style&index=0&id=031955c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031955c2",
  null
  
)

export default component.exports